/* eslint-disable @next/next/no-img-element -- favicon/external/data-URI; next/image migration impractical for these dynamic logo/signature sources */

import { cn } from '@/lib/utils';

interface InstitutionLogoProps {
  logo: string;
  className?: string;
}

export function InstitutionLogo({ logo, className }: InstitutionLogoProps) {
  return (
    <img
      src={logo}
      alt=""
      width={16}
      height={16}
      className={cn('h-4 w-4 shrink-0 rounded-sm object-contain', className)}
      onError={(e) => {
        // If favicon fails to load, hide it
        e.currentTarget.style.display = 'none';
      }}
    />
  );
}
